// extracted by mini-css-extract-plugin
export default {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","container":"timer_container__sM-U+"};